module.exports = __webpack_public_path__ + "static/media/homem-trabalhando.2a22ff1e.png";